<template>
  <div>
    <keep-alive :include="['DashboardV2']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "AppV2",
  mounted() {
    import("../../assets/css/styles-v2.css");
  },
};
</script>